

import { useContext } from 'react';
import { Context_Navigation } from '../../Data/ContextProvider';

const menuButton =  "/Images/MenuButton.png";



// This function is the main header shown at the top
export default function MenuBar() {

    const [Navigation_GVars, Update_Navigation_GVars] = useContext(Context_Navigation);

    function Menu_Toggle_Modal() {
        Update_Navigation_GVars(Navigation_GVars => ({ ...Navigation_GVars, showMainMenu: !Navigation_GVars.showMainMenu }));
    }


    return (
        <div>
        
            {Navigation_GVars.welcomeText ?
                <> <div className="welcomeHeader_1"><h2> Welcome to the Scaling Hub!</h2></div >
                
                <div className="welcomeHeader_2">   <h4> Legal and Operational Tools to Help You Scale Your Business</h4></div > </> : <></>
}
        <div className='menu_Button_Box' >
                < img src={menuButton} className="menu_Button_Disk" onClick={Menu_Toggle_Modal} />
        </div>

            {Navigation_GVars.showMainMenu ? <>
                <div className="Menu_Modal_Background" onClick={Menu_Toggle_Modal} > </div>
                < div className="menu_Bar" onClick={Menu_Toggle_Modal} >

                   <a className="menu_Bar_Button1" href="../index">  Home  </a>
                    

                    <a className="menu_Bar_Button2" href="../business_model">  Check Your Business Model  </a> 

                    <a className="menu_Bar_Button3" href="../explore_laws">  Explore Relevant Laws and Regulations  </a> 

                    <a className="menu_Bar_Button4" href="../investment_hub">  The Investment Hub  </a> 
                    
                    <a className="menu_Bar_Button5" href="../about">  About this Website  </a> 

                    <div className='menu_Bar_EndBox' >  </div>

                </div>  </> : <></>}



        </div>
    );
}

